<template>
  <div>
  </div>
</template>

<script>
// import * as THREE from 'three'
// var Fresnel = ;

var THREE = {
  ...require('three'),
  ...require('three/examples/jsm/loaders/OBJLoader.js'),
}

export default {
  props: {
    player: {}
  },
  data () {
    return {
      rAFID: 0,
      rotate: new THREE.Object3D(),
      geo: false,
      mat: false,
      obj: false
    }
  },
  methods: {
    setup ({ object }) {
      // this.mat =

      let matcap = require('./matcap/mc15.jpg')
      let alphaMap = require('./matcap/mc09-mod.jpg')
      console.log(matcap)

      let loader = new THREE.TextureLoader()

      this.mat = new THREE.MeshMatcapMaterial({
        transparent: true,
        color: new THREE.Color(this.player.color).offsetHSL(0.0, 1.0, 0.1),
        matcap: loader.load(matcap),
        alphaMap: loader.load(alphaMap)
      })

      // this.mat = new THREE.MeshPhongMaterial({
      //   refractionRatio: 0.98,
      //   reflectivity: 0.9,
      //   textureCube: this.$parent.$parent.engine.cubeCamera.renderTarget.texture,
      //   transparent: true,
      //   opacity: 0.9,
      //   color: new THREE.Color(this.player.color).offsetHSL(0.0, 1.0, 0.1)
      // })
      // this.$parent.$parent.engine.cubeCamera.renderTarget.texture.mapping = THREE.CubeRefractionMapping
      // var light = new THREE.PointLight(0xffffff, 1, 10000000)
      // light.position.set(50, 50, 50)
      // this.rotate.add(light)

      this.obj = object
      this.obj.material = this.mat
      this.mat.needsUpdate = true

      this.rotate.add(this.obj)
      this.obj.scale.multiplyScalar(10)

      let pos = this.$parent.$parent.locateCellCore({ player: this.player })

      this.rotate.position.x = pos.x
      this.rotate.position.y = pos.y
      // this.rotate.position.y -= 10

      this.rotate.rotation.x = Math.PI * 0.5

      let rAF = () => {
        this.rAFID = requestAnimationFrame(rAF)
        this.obj.rotation.y += 0.03
      }
      this.rAFID = requestAnimationFrame(rAF)

      this.$parent.$emit('add', this.rotate)
    }
  },
  mounted () {
    var loader = new THREE.OBJLoader();

    // load a resource
    loader.load(
      // resource URL
      require('file-loader!./diamond.obj'),
      // called when resource is loaded
      ( object ) => {
        this.setup({ object: object.children[0] })
      },
      // called when loading is in progresses
      function ( xhr ) {

        console.log( ( xhr.loaded / xhr.total * 100 ) + '% loaded' );

      },
      // called when loading has errors
      function ( error ) {

        console.log( 'An error happened' );

      }
    );

    // this.geo = new THREE.IcosahedronBufferGeometry(15, 1)
  },
  beforeDestroy () {
    cancelAnimationFrame(this.rAFID)
    this.$parent.$emit('remove', this.rotate)
  }
}
</script>

<style>
</style>
